/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for common paging services/utilities.
 */
'use strict';

angular
  .module('services.paging', ['http.activities'])
  /**
   * A factory with common paging utilities.
   */
  .factory('pagingUtils', function (httpActivities, $q, ALERT_EVENTS, $rootScope, $filter) {
    return {
      /**
       * Paging Info object with properties for pagination.
       */
      pagingInfo: {
        //default values
        activity: {
          currentPage: 1,
          itemsPerPage: 20,
          totalPages: 1,
          totalItems: 0,
          sortBy: 'date',
          ascending: false,
          items: []
        },
        audit: {
          currentPage: 1,
          itemsPerPage: 20,
          totalPages: 1,
          totalItems: 0,
          sortBy: 'date',
          ascending: false,
          items: []
        },
        bulkRestoreAllRecords: {
          currentPage: 1,
          itemsPerPage: 20,
          totalPages: 1,
          totalItems: 0,
          sortBy: 'lastModified',
          ascending: true,
          items: []
        },
        bulkRestoreDetails: {
          currentPage: 1,
          itemsPerPage: 20,
          totalPages: 1,
          totalItems: 0,
          sortBy: 'sfName',
          ascending: true,
          items: []
        },
        bulkRestoreSelectedRecords: {
          currentPage: 1,
          itemsPerPage: 20,
          totalPages: 1,
          totalItems: 0,
          sortBy: 'lastModified',
          ascending: true,
          items: []
        },
        metadataRestoreDetails: {
          currentPage: 1,
          itemsPerPage: 20,
          totalPages: 1,
          totalItems: 0,
          sortBy: 'path',
          ascending: true,
          items: []
        }
      },

      /**
       * Utility to update the activity pagingInfo properties with provided parameters.
       * @param param The paging param object.
       * @param Number [param.currentPage = 1] The current selected page.
       * @param String [param.sortBy = 'date'] The field to sort by.
       * @param Boolean [param.ascending = true] True if sort in ascending order.
       */
      updateActivities: function (param) {
        var self = this;
        self.pagingInfo.activity.currentPage = param.currentPage || 1;
        self.pagingInfo.activity.sortBy = param.sortBy || 'date';
        self.pagingInfo.activity.ascending = param.ascending;
      },

      /**
       * Utility to update the audit pagingInfo properties with provided parameters.
       * @param param The paging param object.
       * @param Number [param.currentPage = 1] The current selected page.
       * @param String [param.sortBy = 'date'] The field to sort by.
       * @param Boolean [param.ascending = true] True if sort in ascending order.
       */
      updateAudit: function (param) {
        var self = this;
        self.pagingInfo.audit.currentPage = param.currentPage || 1;
        self.pagingInfo.audit.sortBy = param.sortBy || 'date';
        self.pagingInfo.audit.ascending = param.ascending;
      },

      /**
       * Utility to update the bulk restore all records pagingInfo properties with provided parameters.
       * @param param The paging param object.
       * @param Number [param.currentPage = 1] The current selected page.
       * @param String [param.sortBy = 'date'] The field to sort by.
       * @param Boolean [param.ascending = true] True if sort in ascending order.
       */
      updateBulkRestoreAllRecords: function (param) {
        var self = this;
        self.pagingInfo.bulkRestoreAllRecords.currentPage = param.currentPage || 1;
        self.pagingInfo.bulkRestoreAllRecords.sortBy = param.sortBy || 'date';
        self.pagingInfo.bulkRestoreAllRecords.ascending = param.ascending;
      },

      /**
       * Utility to update the bulk restore details pagingInfo properties with provided parameters.
       * @param param The paging param object.
       * @param {Number} [param.currentPage = 1] - The current selected page.
       * @param {String} [param.sortBy = 'date'] - The field to sort by.
       * @param {Boolean} [param.ascending = true] - True if sort in ascending order.
       */
      updateBulkRestoreDetails: function (param) {
        var self = this;
        self.pagingInfo.bulkRestoreDetails.currentPage = param.currentPage || 1;
        self.pagingInfo.bulkRestoreDetails.sortBy = param.sortBy || 'sfName';
        self.pagingInfo.bulkRestoreDetails.ascending = param.ascending;
      },

      /**
       * Utility to update the bulk restore selected records pagingInfo properties with provided parameters.
       * @param param The paging param object.
       * @param Number [param.currentPage = 1] The current selected page.
       * @param String [param.sortBy = 'date'] The field to sort by.
       * @param Boolean [param.ascending = true] True if sort in ascending order.
       */
      updateBulkRestoreSelectedRecords: function (param) {
        var self = this;
        self.pagingInfo.bulkRestoreSelectedRecords.currentPage = param.currentPage || 1;
        self.pagingInfo.bulkRestoreSelectedRecords.sortBy = param.sortBy || 'date';
        self.pagingInfo.bulkRestoreSelectedRecords.ascending = param.ascending;
      },

      /**
       * Utility to get the current page, checking to make sure page is within boundary.
       * @param {Number} page - The new page.
       * @param {Number} totalPage - The total number of pages.
       *
       * @return {Number} The current page.
       */
      getCurrentPage: function (page, totalPages) {
        var currentPage;

        // If user enters page via text box, pageNo comes in as string and we need to convert to Int.
        if (_.isNumber(page)) {
          currentPage = page;
        } else {
          currentPage = parseInt(page);
          // If page is NaN, return 0 to set to currentPage
          if (_.isNaN(currentPage)) {
            currentPage = 0;
            return currentPage;
          }
        }

        if (currentPage < 1) {
          currentPage = 1;
        } else if (currentPage > totalPages) {
          currentPage = totalPages;
        }

        return currentPage;
      },

      /**
       * Utility to fetch the activities object.
       *
       * @returns  {promise} - A promise that when resolved will include an activities object.
       */
      getActivities: function () {
        var self = this;
        var offset = (self.pagingInfo.activity.currentPage - 1) * self.pagingInfo.activity.itemsPerPage,
          params = {
            limit: self.pagingInfo.activity.itemsPerPage,
            offset: offset,
            sort: self.pagingInfo.activity.sortBy,
            ascending: self.pagingInfo.activity.ascending
          };
        return httpActivities.getActivities(params).then(
          function (activities) {
            self.pagingInfo.activity.items = activities.rows;
            self.pagingInfo.activity.totalItems = activities.count;
            self.pagingInfo.activity.totalPages = Math.ceil(
              self.pagingInfo.activity.totalItems / self.pagingInfo.activity.itemsPerPage
            );
          },
          function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('LOAD_LOG_DATA_FAILED'));
          }
        );
      },

      /**
       * Utility to fetch the audit event object.
       *
       * @returns  {promise} - A promise that when resolved will include an audit event object.
       */
      getAuditEvents: function () {
        var self = this;
        var offset = (self.pagingInfo.audit.currentPage - 1) * self.pagingInfo.audit.itemsPerPage,
          params = {
            limit: self.pagingInfo.audit.itemsPerPage,
            offset: offset,
            sort: self.pagingInfo.audit.sortBy,
            ascending: self.pagingInfo.audit.ascending
          };
        return httpActivities.getAuditEvents(params).then(
          function (auditEvents) {
            self.pagingInfo.audit.items = auditEvents.rows;
            self.pagingInfo.audit.totalItems = auditEvents.count;
            self.pagingInfo.audit.totalPages = Math.ceil(
              self.pagingInfo.audit.totalItems / self.pagingInfo.audit.itemsPerPage
            );
          },
          function () {
            $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('GET_AUDIT_EVENTS_FAILED'));
          }
        );
      }
    };
  });
